// extracted by mini-css-extract-plugin
module.exports = {"matchesSection":"cricket_matchesSection__2pttW","matchesNavMenu":"cricket_matchesNavMenu__28F4W","navItem":"cricket_navItem__3mURg","active":"cricket_active__33DzX"};